export default __webpack_public_path__ + "static/media/logo.48772642.png";